/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LabelsIcon = ({ width = 24, height = 24, hidden = false, title = 'Labels' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33.703 15.507 18.493.297A1.014 1.014 0 0 0 17.776 0H5.014A1.014 1.014 0 0 0 4 1.014v12.762a1.015 1.015 0 0 0 .297.717l15.21 15.21a1.014 1.014 0 0 0 1.434 0l12.762-12.762a1.014 1.014 0 0 0 0-1.434ZM11 10a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z"
    />
    <path
      d="m33.703 21.707-.804-.793L20.94 32.707a1.024 1.024 0 0 1-1.434 0l-15.21-15A.992.992 0 0 1 4 17v3a.994.994 0 0 0 .297.708l15.21 15a1.025 1.025 0 0 0 1.434 0l12.762-12.586a.99.99 0 0 0 0-1.415Z"
    />
  </svg>`;
};
